import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    Breadcrumb, Col, Row, Layout,
} from 'antd';
import { addGroup } from './redux/actions/add_group.actions';
import AddGroupForm from './components/User_group_create_table';

const BreadcrumbItem = Breadcrumb.Item;
const breadcrumb_position = { margin: '0 0 1% 0' };
const layout_position = { padding: '0 4%' };

export default connect(null, { addGroup })(class AddGroup extends Component {
  submitForm = params => this.props.addGroup(params);

  render() {
      return (
          <Layout style={layout_position}>
              <Row>
                  <Col span={24}>
                      <Breadcrumb style={breadcrumb_position}>
                          <BreadcrumbItem><Link to="/UserManagement/User_group">Group Management</Link></BreadcrumbItem>
                          <BreadcrumbItem>Add Group</BreadcrumbItem>
                      </Breadcrumb>
                      <h3 className="page-title">Add Group</h3>
                      <h3 className="page-subhead subhead">
                          Complete the details below to create a new user group within the
                          SuperBike Factory platform.
                      </h3>
                  </Col>
              </Row>
              <Row>
                  <AddGroupForm onSubmit={this.submitForm} />
              </Row>
          </Layout>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_create/index.js